/** Byte order. The Esiur wire format is little-endian by default. */
export enum Endian {
  Big = 0,
  Little = 1,
}
